import React from "react";
import { PostHogProvider } from "posthog-js/react";
import type { PostHogConfig } from "posthog-js";
import { settings } from "@/data/constants/appSettings";

const options: Partial<PostHogConfig> = {
  api_host: settings.posthog_host,

  session_recording: {
    maskTextSelector: ".sensitive",
    recordCrossOriginIframes: false,
  },
};

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

const isAnalyticsConfigured = () => {
  return Boolean(
    settings.posthog_key &&
      settings.posthog_host &&
      settings.posthog_key.trim() !== "" &&
      settings.posthog_host.trim() !== ""
  );
};

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
  children,
}) => {
  if (!isAnalyticsConfigured()) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider apiKey={settings.posthog_key} options={options}>
      {children}
    </PostHogProvider>
  );
};
